<template>
  <Card class="stats-card">
    <i-circle :percent="attRate" :dashboard="true">
        <span class="demo-Circle-inner" style="font-size:24px">%{{attRate}}</span>
    </i-circle>
    <div class="stats-title"><b>Attendence Conversation Rate</b></div>
    <div class="stats-title">Registrations vs Total Attendees</div>
  </Card>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import moment from 'moment'
export default {
  computed: {
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    }),
    ...mapGetters('registrations', {
      findRegistrationsInStore: 'find'
    }),
    ...mapGetters('realtime-stats', {
      statsInStore: 'find'
    }),
    ...mapGetters('page-settings', {
      pageSettings: 'getCopy',
    }),
    regCount(){
      return this.findRegistrationsInStore({
        query: {
            $limit: 0,
            webcastId: this.webcast._id
        }
      }).total
    },
    attRate(){
      if(!this.pageSettings.registrationEnabled){
        return 0;
      } else {
        return  _.round((this.attCount*100)/this.regCount,0);
      }
    },
    attCount(){
      var stats =  this.statsInStore({
        query: {
          'webcastId': this.webcast._id,
          'sessionId': this.webcast.currentSessionId
        }
      })
      let attCount = 0;
      let deviceCount = 0;
      
      if(this.pageSettings.registrationEnabled){
        _.forEach(stats.data, function(stat) {
          attCount += stat.totalAtt
        });

        return attCount
      } else {
        _.forEach(stats.data, function(stat) {
          deviceCount += stat.totalDevice
        });
        return deviceCount
      }
    },
  },
  methods: {
  },
  created(){
  }
}
</script>

<style>

</style>
